import React from "react";

// 确保传递给 createContext 的默认值数据结构是调用的组件（consumers）所能匹配的！
export const GlobalContext = React.createContext({
  account: undefined,
  updateAccount: () => {},
  passwordCheckMsg: "",  // 密码修改提醒的提示语
  updatePasswordCheckMsg: () => {},
  skipPasswordCheck: false,  // 是否跳过检查密码强度和有效期
  updateSkipPasswordCheck: () => {},
  skipChangePassword: false,  // 强制密码修改页面是否显示下次修改
  updateShipChangePassword: () => {},
});
export default GlobalContext;
